import { FileFormatted } from "@/models/file";

export interface WizardConfigurationFile {
  fileId: string;
  fileUrl: string;
  fileName: string;
}

export interface WizardConfiguration {
  language: string;
  timeZone: string;
  serial: string;
  roomName: string;
  deviceDisplayMode: number;
  showCustomLogo: boolean;
  customLogo?: WizardConfigurationFile;
  showCustomBackgrounds: boolean;
  customBackgrounds: WizardConfigurationFile[];
  userName?: string;
  password?: string;
  wifiSSID?: string;
  wifiPassword?: string;
  screenSharingPin: boolean;
  rebootTime: string;
  presentationSetupMode: number;
  externalAccounts: unknown;
}

export const fileFormatted2WizardConfigurationFile = (
  f: FileFormatted
): WizardConfigurationFile => {
  return {
    fileId: f.id || "",
    fileUrl: f.path,
    fileName: f.name,
  };
};

//
// language: this.language?.code || "",
//   timeZone: this.timezone?.value || "",
//   serial: this.license,
//   roomName: this.roomName,
//   customLogo: this.logoId,
//   customBackgrounds: this.bgId ? [...this.bgId] : undefined,
//   userName: this.defaultUserName,
//   wifiSSID: this.showCustomWifi ? this.customSSID : null,
//   wifiPassword: this.showCustomWifi ? this.customPass : null,
//   customServer: this.customServer,
//   screenSharingPin: this.screenSharingPin,
//   rebootTime: this.rebootTime,

// export const WizardConfigurationDeserializer = (
//   /* eslint-disable-next-line  @typescript-eslint/explicit-module-boundary-types */
//   input: any
// ): WizardConfiguration => {
//   return {
//     deviceConfigurationId: input.deviceConfigurationId || "",
//     deviceId: input.deviceId || "",
//     deviceName: input.deviceName || "",
//     deviceDescription: input.deviceDescription || "",
//     installedProduct: input.installedProduct || "",
//     installedVersion: input.installedVersion || "",
//     releaseType: input.releaseType || "",
//     licenseKey: input.licenseKey,
//     status: input.status || "",
//     releaseChannel: input.releaseChannel || "",
//     tenantCode: input.tenantCode || "",
//     label: input.label || "",
//     licensePackageId: input.licensePackageId,
//     webWizardConfig: input.webWizardConfig,
//     // clientConfig: string;
//   };
// };
